module.exports = __webpack_public_path__ + "img/icon_memo_filter.ad9be817.svg";